export default class Stat {
    constructor({ id = 0, name, formula = 'ROW', minIndex = 1, maxIndex = 10, valueOverrides = {} }) {
        this.id = id;
        this.name = name;
        this.formula = formula;
        this.minIndex = minIndex;
        this.maxIndex = maxIndex;
        this.valueOverrides = valueOverrides;
    }

    setValue(index, value) {
        this.valueOverrides = {
            ...this.valueOverrides,
            [index]: {
                active: true,
                value
            }
        }
    }

    removeValue(index) {
        delete this.valueOverrides[index];
        this.valueOverrides = { ...this.valueOverrides };
    }

    getValue(index) {
        return this.valueOverrides.hasOwnProperty(index) ? this.valueOverrides[index].value : null;
    }

    hasValue(index) {
        return this.getValue(index) != null && this.valueOverrides[index].active;
    }
}